import React, { useState } from 'react';
import transformArrayToObject from '~/utils/transformArrayToObject';

const FileProv = React.createContext({
  data: {
    data: [],
    page: 0,
    totalCount: 0,
  },
  records: {},
  setData: () => null,
  modifyData: () => null,
  deleteRecord: () => null,
});

export function FileProvider({ children }) {
  const [records, setRecords] = useState({});
  const [data, setData] = useState({
    data: [],
    page: 0,
    totalCount: 0,
  });

  function addRecords(newData) {
    setData({ ...data, ...newData });

    const newRecords = transformArrayToObject(newData.data);
    setRecords({...records, ...newRecords});

    return newData;
  }

  function delRecord(id) {
    const index = data.data.findIndex(r => r.id === id);
    if (index > -1) {
      data.data.splice(index, 1);
      setData({ ...data, data: [ ...data.data ] });
    }
  }

  return (
    <FileProv.Provider value={{ data, addRecords, delRecord, records }}>
      {children}
    </FileProv.Provider>
  );
}

export default FileProv;
